module.exports = __webpack_public_path__ + "img/Photo.22f73eca.svg";